import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SettingsState {
  isOpen: boolean;
  section: string;
}

const initialState: SettingsState = {
  isOpen: false,
  section: '',
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    openSettings: (state, action: PayloadAction<{ section?: string }>) => {
      state.isOpen = true;
      if (action.payload.section) {
        state.section = action.payload.section;
      }
    },
    closeSettings: (state) => {
      state.isOpen = false;
    },
    setSettingsSection: (state, action: PayloadAction<string>) => {
      state.section = action.payload;
    },
  },
});

export const { openSettings, closeSettings, setSettingsSection } = settingsSlice.actions;
export default settingsSlice.reducer;
